module.exports = __webpack_public_path__ + "img/blue_122.8fbf05ff.png";